import Vector from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import Feature from 'ol/Feature';
import Geolocation from 'ol/Geolocation';
import Point from 'ol/geom/Point';
import Control from 'ol/control/Control';
import * as olExtent from 'ol/extent';

import addPixelPadding from '@mapsight/lib-ol/coordinate/addPixelPadding';

import styleGeolocation from '../styles/geolocation';
import * as config from '../../config';

const GEOLOCATION_MIN_ACCURACY = 151; // in meters

/**
 * @constructor
 * @extends {import('ol/Control').Control}
 * @param {any} geolocation geolocation
 * @param {Object=} options Control options.
 */
class CenterOnGeolocationControl extends Control {
	constructor(geolocation, options = {}) {
		super({
			element: document.createElement('div'),
			...options,
		});

		this.geolocation = geolocation;
		this.element.addEventListener('click', () => {
			const view = this.getMap().getView();

			const center = addPixelPadding(
				view.getResolution(),
				geolocation.getPosition(),
				view.get('padding')
			);

			view.animate({
				center: center,
				zoom: 21,
				duration: 500,
			});
		});
		this.renderButtonComponent();
	}

	renderButtonComponent() {
		this.element.className = `bssp-center-geolocation-control ${
			this.isActive ? 'bssp-center-geolocation-control--active' : ''
		}`;
		this.element.innerHTML =
			'<i class="bssp-icon bssp-icon--compass"></i> Zentrieren';
	}

	setIsActive(isActive) {
		this.isActive = isActive;
		this.renderButtonComponent();
	}
}

export default function (
	projection,
	tracking = true,
	minAccuracy = GEOLOCATION_MIN_ACCURACY
) {
	const geolocationVectorSource = new Vector();
	const geolocationVectorLayer = new VectorLayer({
		updateWhileInteracting: true,
		source: geolocationVectorSource,
	});
	const geolocationPositionFeature = new Feature();
	geolocationPositionFeature.setStyle(styleGeolocation);
	geolocationVectorSource.addFeature(geolocationPositionFeature);

	const geolocation = new Geolocation({
		projection: projection,
		tracking: tracking,
	});
	const geolocationControl = new CenterOnGeolocationControl(geolocation);

	function updateGeolocationFeature() {
		const accuracy = geolocation.getAccuracy();
		const coordinates = geolocation.getPosition();

		// update geometry in layer
		const geometry =
			accuracy <= minAccuracy && coordinates
				? new Point(coordinates)
				: null;
		geolocationPositionFeature.setGeometry(geometry);

		// update control state
		const isInBounds =
			coordinates && olExtent.containsCoordinate(config.extent, coordinates);
		geolocationControl.setIsActive(isInBounds);
	}

	geolocation.on('change:position', updateGeolocationFeature);
	geolocation.on('change:accuracy', updateGeolocationFeature);

	return {
		geolocationVectorLayer: geolocationVectorLayer,
		geolocationControl: geolocationControl,
	};
}
